import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  confirmDelete,
  deletechapitre,
  deletedQuestion,
  failedDelete,
  serverError,
} from './../../../../core/models/messages';
import { ToastMessage } from './../../../../core/models/template';
import { CompanyService } from './../../../../core/services/company/company.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { PageEvent } from '@angular/material/paginator';
import { EvaluationService } from '@core/services/evaluation/evaluation.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-details-eval',
  templateUrl: './details-eval.component.html',
  styleUrls: ['./details-eval.component.css'],
})
export class DetailsEvalComponent {
  expandedIndex: number | null = null;
  displayButton?: boolean = true;
  selectedTypeResponse: string | null = null;
  esn_id!: string | null;
  evaluation_id!: string | null;
  ideval: any;
  chapitreLists: any[] = [];
  chapitreList: { id: number; name: string }[] = [];
  chapitreListquest: { id: number; name: string }[] = [];
  //Listquestion: any;
  Listquestion1:any
  max: number = 5;
  /* any */
delet: boolean = false;
save: boolean = false;
  type = [
    { id: '1', name: 'Annuelle' },
    { id: '2', name: 'Suivi' },
  ];
  currentSortDirection: number = 2;
  selectedtemplate: any;
  questionForm: FormGroup = this.createQuestionForm();
  totalItems!: number;
  chapitreDetails: any;
  templateForm: FormGroup = this.createsubjectForm();
  subjectForm: FormGroup = this.createSubjectFamilleForm();
  formevaluationclonerAdmin : FormGroup = this.createevaluationclonerFormAdmin();
  /* unsubscription */
  DetailsForm: FormGroup = this.createsubjectForm();
  private unsubscribeAll: Subject<void> = new Subject();
  itemsPerPage: number = 5;
  startIndex: number = 0;
  endIndex: number = 5;
  totalComments!: number;
  modalRef?: BsModalRef;
  file: any;
  id!: number;
  Listtemplate: any;
  idch!: string;
  fileError: string = '';
  fileExtention: string = '';
  listnote: any;
  name: any;
  defauttemplate:any;
  defaulttrue:any;
  pagination : boolean =false;
  mode: string = 'create';
  pageSizeOptions = [5, 10];
  pageSizeQuestions = 5;
  pageSizeQuestionsAdmin =5;
  currentPageQuestions = 0;
  totalElementsQuestions = 0
  templateQuestions : any[] = []
  pageSizeSubjects = 5;
  currentPageSubjects = 0;
  totalElementsSubjects = 0
  templateSubjects : any[] = []
  idTemplate: number | null = null
  typeTemplate: string | null = null
  searchSubject: Subject<string> = new Subject<string>();
  searchSubjectText : string = ''
  subjectsList : any[] = []
  step_question : any;
  step_family: any;
  questionId: any;
  changesList : any[] = [];
  extractedQuestions :any [] =[];
  displayUpdatequestion : boolean =false;
  constructor(
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private ajouttemlateservice: EsnAppeloffreService,
    private companyservice: CompanyService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private router: Router,
    private evaluationService : EvaluationService
  ) {}
  drop(event: CdkDragDrop<string[]>) {
    this.displayUpdatequestion = true;
    this.step_family = event.currentIndex;
    moveItemInArray(this.templateQuestions, event.previousIndex, event.currentIndex);
    this.templateQuestions.forEach((subject: any, index: number) => {
      subject.step_family = index + 1;
      const eventMock = {
          previousIndex: event.previousIndex,
          currentIndex: event.currentIndex
      } as CdkDragDrop<string[]>;
      this.dropQuestions(eventMock, index);
  });
  }
 
  dropQuestions(event: CdkDragDrop<string[]>, subjectIndex: number) {
    this.displayUpdatequestion = true;
    const subject = this.templateQuestions[subjectIndex];
    if (!subject) return;
    moveItemInArray(subject.questions, event.previousIndex, event.currentIndex);
    subject.questions.forEach((question:any, index:any) => {
        question.step_question = index + 1; 
        question.step_family = subject.step_family;
    });
    const updatedSubject = {
        family_id: subject.family_id,
        family_name: subject.family_name,
        step_family: subject.step_family, 
        questions: subject.questions.map((q:any) => ({
            id: q.id,
            content: q.content,
            template_id: q.template_id,
            type_response: q.type_response,
            archived: q.archived,
            family_id: q.family_id,
            created_at: q.created_at,
            updated_at: q.updated_at,
            step_question: q.step_question,
            step_family: q.step_family,
            eval_family_esn: q.eval_family_esn
        }))
    };
    const existingIndex = this.changesList.findIndex(s => s.family_id === subject.family_id);
    if (existingIndex !== -1) {
        this.changesList[existingIndex] = updatedSubject;
    } else {
        this.changesList.push(updatedSubject);
    }
    this.extractedQuestions = this.changesList.flatMap(subject => 
      subject.questions.map((q:any) => ({
          question_id: q.id,
          step_question: q.step_question,
          step_family: q.step_family
      }))
  );
}

  ngOnInit() {
    this.esn_id = this.localStorageService.getData('clientConnected');
    this.retrieveIdTemplate();
    this.initUserSearchListener();
    this.getTemplateSubjects()
  }
  createevaluationclonerFormAdmin(data?:any) {
    return this.formBuilder.group({
      evaluation_name: [data && data.name, [Validators.required]],
      evaluation_id: [''],
    });
  }
  
  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }
  createsubjectForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name],
      type: [data && data.type],
      dedicated_to: [data && data.dedicated_to],
      esn_id: [this.localStorageService.getData('clientConnected')],
      id: [''],
    });
  }

  toastMessages: ToastMessage = {
    success: 'Ajout de votre Sujet évaluation avec succès',
    error: ' Sujet évaluation avec ce nom existe déjà',
  };
  toastMessages2: ToastMessage = {
    success: 'La question a été ajoutée avec succè',
    error: ' La question avec ce nom existe déjà',
  };
  createSubjectFamilleForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name, [Validators.required]],
    });
  }

  createtemplate() {
    if (this.templateForm.invalid) {
      return;
    }

    this.spinner.show();
    this.ajouttemlateservice
      .ajoutertemplate(this.templateForm.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.evaluation_id = res.data.id;
          this.spinner.hide();
          this.toastr.success(this.toastMessages.success);
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
            this.toastr.error(this.toastMessages.error);
          } else {
            this.toastr.error(serverError);
          }
        },
      });
  }
   chapitreIdNameMap: { [key: string]: string } = {}; // Add this property to store ID-name mapping
  getListchapitreaddquestion(sort?: any) {
    this.ajouttemlateservice
      .getchapitreListaddquest(this.esn_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
        
          this.chapitreListquest = res.data.data;
         
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  createQuestionForm(data?: any) {
    return this.formBuilder.group({
      content: [data && data.content, Validators.required],
      type_response: [data && data.type_response, Validators.required],
      family_id: [data && data.family_id, Validators.required],
      template_id: [null],
    });
  }
  getSubjects(): string[] {
    return Object.keys(this.questionsGroupedBySubject);
  }
  questionsTempList: any[] = [];
  questionsGroupedBySubject: { [key: string]: any[] } = {};

  createoneQuestion() {
    const question = this.questionForm.value;
    const subject = question.chapter_eval_id; 
    if (!this.questionsGroupedBySubject[subject]) {
      this.questionsGroupedBySubject[subject] = [];
    }
  
    this.questionsGroupedBySubject[subject].push(question);
  
    this.questionForm.reset();
    this.closeModal();
  }
  navigateToTemplate() {
    this.router.navigate([
      '/evaluation/template-evaluation'
    ]);
  }
  closeModal() {
    this.modalRef?.hide();
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
    this.subjectForm.reset();
    this.questionForm.reset();
  }
  getChapitreById() {
    if (!this.evaluation_id) {
      return;
    }
    this.spinner.show();
    this.ajouttemlateservice
      .detailchapitre(this.evaluation_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.chapitreDetails = res.data;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  retrieveIdTemplate() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idTemplate = params.params['idTemplate'];
        this.typeTemplate = params.params['typeTemplate'];
        if(this.typeTemplate === "ESN"){
          this.getTemplateQuestions()
          this.displayButton = true;
        }else{
          this.getTemplateQuestionsAdmin()
          this.displayButton = false;
        }
      },
    });
  }
  toastMessages1: ToastMessage = {
    success: 'Modifié de votre question avec succès',
    error: 'question avec ce nom existe déjà',
  };

  openModal(template: TemplateRef<any>, mode: string, data?: any) {
    this.getAllSubjects()
    this.mode = mode;
    if (mode == 'update') {
      this.id = data?.id;
      this.questionForm = this.createQuestionForm(data);
    }
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  
  updateQuestion() {
    this.questionForm.get('template_id')?.patchValue(this.idTemplate)
    if (this.questionForm.value.evaluation_id == '') {
      delete this.questionForm.value.evaluation_id;
    }
    this.companyservice
      .updateQuestionEvaluation(this.id, this.questionForm.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.toastr.success(this.toastMessages1.success);
          this.closeModal();
          this.getTemplateQuestions()
        },
        error: (err) => {
          if (err.error && err.error.message && err.error.message.question) {
            this.toastr.info('Question existe déjà');
          } else {
            this.toastr.error(
              'Erreur du serveur lors de la modification de la famille.'
            );
          }
          this.spinner.hide();
        },
      });
  }
messageupdateavantenregister(){
  if(!this.save)
    {
this.toastr.info("Enregistrer vos questions avant de le modifier");
    }
}
messagedeleteavantenregister(){
  if(!this.delet)
    {
this.toastr.info("Enregistrer vos questions avant de le supprimer");
    }
}
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  /**modifier chapitre evaluation  */

  openModalupdate(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });

    if (data) {
      this.id = data.id;
      this.subjectForm = this.createSubjectFamilleForm(data);
      console.log('resssss',data)
    }
  }
  updateIntervenant() {
    if (this.subjectForm.valid) {
      this.spinner.show();
      this.subjectForm.get('id')?.setValue(this.id);

      this.companyservice.updateFamille(this.id, this.subjectForm.value)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
           this.getTemplateSubjects();
           this.getTemplateQuestions();
            this.toastr.success('La famille a été modifiée avec succès.');
            this.closeModal();
            this.subjectForm.reset();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastr.error('le nom du sujet existe déjà');
            }
          },
        });
    }
  }
  openModalupdatequestion(
    template: TemplateRef<any>,
    data?: any,
    mode?: string
  ) {

    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    if (data) {
      console.log('data update question',data)
      this.id = data.id;
      this.questionForm = this.createQuestionForm(data);
    }
  }

  createSearchFormSubject(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : null],
    });
  }
  reset() {
    this.searchSubjectText = ''
    this.currentPageSubjects = 0
    this.getTemplateSubjects();
  }
  openDeleteAlert(id: any) {

    Swal.fire({
      title: `${confirmDelete} cette question ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteQuestion(id);
      } else if (result.isDismissed) {
        Swal.fire(failedDelete, '', 'error');
      }
    });
  }
  /* delete question */
  deleteQuestion(id: any) {
    this.spinner.show();
    this.companyservice
      .deleteQuestionEvaluation(id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.spinner.hide();
            this.toastr.success(deletedQuestion);
            //this.getListQuestion();
            this.getTemplateQuestions()
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  /* delete sujet*/
  deletechapitre(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Supprimer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.companyservice.deletefamille(id).subscribe({
          next: (res) => {
            if (res.status === 200) {
              this.toastr.success("Sujet d'évaluation  a été supprimé.");
              this.getTemplateSubjects();
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.toastr.error('Cette famille a des questions associées et ne peut pas être supprimée');
          },
        });
      }
      
    });
  }
  openModalaAdminClone(template: TemplateRef<any>, data?: any, mode?: string) {
     this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  clonerEvaluationAdminCloner() {
    if (this.formevaluationclonerAdmin.invalid) return
    this.spinner.show();
    this.ajouttemlateservice
      .clonagetemplateAdmin(this.idTemplate,this.formevaluationclonerAdmin.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.navigateToTemplateEval();
          this.spinner.hide();
          this.toastr.success(this.toastMessages1.success);
          this.formevaluationclonerAdmin.reset();
          this.closeModal();
        },

        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
              this.toastr.error('le nom d\'évaluation existe déja, veillez choisir un nouveau nom d\'évaluation');
            } else {
              this.toastr.error('le nom d\'évaluation existe déja, veillez choisir un nouveau nom d\'évaluation');
            }
          }
        },
      });
  }
  getTemplateQuestionsAdmin(){
    this.spinner.show();
    this.evaluationService
    .listQuestion(this.idTemplate)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {            
              this.templateQuestions = res.data ? res.data : [];
              this.totalElementsQuestions = res.data?.total
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.templateQuestions = []
            this.totalElementsQuestions = 0
            if (err?.error) {
              this.toastr.error(serverError);
            }
          },
        });
}
  getTemplateQuestions(){
      this.spinner.show();
      this.evaluationService
          .getTemplateQuestions(this.idTemplate)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {
              if (res.status == 200) {                
                this.templateQuestions = res.data?.data ? res.data?.data : [];
                this.totalElementsQuestions = res.data?.total;
                this.spinner.hide();
              }
            },
            error: (err) => {
              this.spinner.hide();
              this.templateQuestions = []
              this.totalElementsQuestions = 0
              if (err?.error) {
                this.toastr.error(serverError);
              }
            },
          });
  }
  updateStep(){
    let data = {
      updates: this.extractedQuestions
    };
    this.spinner.show();
    this.evaluationService
        .updateMultipleSteps(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {                
              this.getTemplateQuestions();
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.templateQuestions = []
            this.totalElementsQuestions = 0
            if (err?.error) {
              this.toastr.error(serverError);
            }
          },
        });
}
resetupdate(){
  this.getTemplateQuestions();
}
    submitData() {
    if (this.mode == 'create') {
      this.addQuestion();
    } else {
      this.updateQuestion();
    }
  }

  addQuestion() {      
    if (this.questionForm.invalid) return

      this.spinner.show();
      this.questionForm.get('template_id')?.patchValue(this.idTemplate)
      this.evaluationService
        .addQuestion(this.questionForm.value)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.getTemplateQuestions()
              
              this.questionForm.reset();
              this.closeModal();
              this.spinner.hide();
              this.toastr.success('La question a été ajoutée avec succès.');
            }
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastr.error(serverError);
            }
          },
        });
  }

  onPageChangeQuestions(e: PageEvent): void {
    this.pageSizeQuestions = e.pageSize;
    this.currentPageQuestions = e.pageIndex;
    this.getTemplateQuestions()
  }

  getTemplateSubjects(){
    this.spinner.show();
    const params = {
      page: this.currentPageSubjects,
      per_page : this.pageSizeSubjects,
      ...(this.searchSubjectText?.length > 0 && { search: this.searchSubjectText }),
    }
    this.evaluationService
        .getTemplateSubjects(params)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {            
            if (res.status == 200) {
              this.templateSubjects = res.data?.data ? res.data?.data : []
              this.totalElementsSubjects = res.data?.total
              this.spinner.hide();
            }
          },
          error: (err) => {
            this.spinner.hide();
            this.templateSubjects = []
            this.totalElementsSubjects = 0
            if (err?.error) {
              this.toastr.error(serverError);
            }
          },
        });
  }

  onPageChangeSubjects(e: PageEvent): void {
        this.pageSizeSubjects = e.pageSize;
        this.currentPageSubjects = e.pageIndex;
        this.getTemplateSubjects()
  }

  addSubject() {
        if (this.subjectForm.invalid) return
    
          this.spinner.show();
          this.evaluationService
            .addSubject(this.subjectForm.value)
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe({
              next: (res) => {
                if (res.status == 200) {
                  this.getTemplateSubjects()
                  this.subjectForm.reset()
                  this.closeModal();
                  this.spinner.hide();
                  this.toastr.success('Le sujet a été ajouté avec succès.');
                }
              },
              error: (err) => {
                this.spinner.hide();
                if (err?.error) {
                  this.toastr.error('le nom du sujet existe déjà');
                }
              },
            });
  }

  onSearchInputSubject(event: Event): void {
      const inputValue = (event.target as HTMLInputElement).value;
      this.searchSubject.next(inputValue);
  }

  getAllSubjects(){
    this.evaluationService
        .getAllSubjects()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {               
              this.subjectsList = res.data ? res.data : []
            }
          },
          error: (err) => {
            this.subjectsList = []
            if (err?.error) {
              this.toastr.error("La liste des sujets n'a pas pu être renvoyée");
            }
          },
        });
}

  navigateToTemplateEval() {
    this.router.navigate([
      '/evaluation/template-evaluation',
    ]);
  }

  private initUserSearchListener(): void {
    this.searchSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        this.searchSubjectText = searchTerm
        this.currentPageSubjects = 0
        this.getTemplateSubjects();
      });
  }

}
